/**
 * mare-filtro.js — Maré Chocolate
 */

(function () {
  'use strict';

  var COLECOES_IGNORAR = ['all', 'frontpage', 'chocolate'];
  var tentativas = 0;

  function rodar() {
    tentativas++;
    if (tentativas > 200) return; // desiste após ~10s

    var filtroEl = document.querySelector('live-product-filter-awwpsddhmadawaxe1taigenblock3ab25d6nfeqwi');
    if (!filtroEl) {
      setTimeout(rodar, 50);
      return;
    }

    if (filtroEl.dataset.ok) return;
    filtroEl.dataset.ok = '1';

    // Remove duplicatas
    var todos = document.querySelectorAll('live-product-filter-awwpsddhmadawaxe1taigenblock3ab25d6nfeqwi');
    for (var i = 1; i < todos.length; i++) todos[i].remove();

    // ── Botão toggle ──
    if (!document.getElementById('mare-btn-filtro')) {
      var btn = document.createElement('button');
      btn.id = 'mare-btn-filtro';
      btn.innerHTML = '&#9776; <span>Filtrar produtos</span>';
      btn.style.cssText = 'display:inline-flex;align-items:center;gap:7px;padding:9px 18px;margin-bottom:16px;border:1px solid #C0541A;border-radius:3px;background:transparent;color:#C0541A;font-size:0.8rem;font-weight:500;letter-spacing:0.05em;cursor:pointer;transition:background 0.2s,color 0.2s;';
      btn.onmouseenter = function() { btn.style.background='#C0541A'; btn.style.color='#fff'; };
      btn.onmouseleave = function() { btn.style.background='transparent'; btn.style.color='#C0541A'; };
      filtroEl.parentElement.insertBefore(btn, filtroEl);
      filtroEl.style.display = 'none';

      btn.onclick = function() {
        var aberto = filtroEl.style.display !== 'none';
        filtroEl.style.display = aberto ? 'none' : '';
        btn.querySelector('span').textContent = aberto ? 'Filtrar produtos' : 'Ocultar filtros';
      };
    }

    // ── Popula select de coleções ──
    var select = filtroEl.querySelector('[data-filter="category"]');
    if (select && select.options.length <= 1) {
      fetch('/collections.json?limit=30')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          (data.collections || []).forEach(function(c) {
            if (COLECOES_IGNORAR.indexOf(c.handle) !== -1) return;
            var opt = document.createElement('option');
            opt.value = c.handle;
            opt.textContent = c.title;
            select.appendChild(opt);
          });
        });
    }

    // ── Contador inicial ──
    atualizarContador(filtroEl, getCardsHome().length, getCardsHome().length);

    // ── Eventos ──
    filtroEl.onclick = function(e) {
      var action = e.target.closest && e.target.closest('[data-action]');
      if (!action) return;
      if (action.dataset.action === 'apply') aplicar(filtroEl);
      if (action.dataset.action === 'reset') limpar(filtroEl);
    };
  }

  function getCardsHome() {
    return Array.prototype.filter.call(
      document.querySelectorAll('product-card-link'),
      function(el) {
        return !el.closest('.menu-drawer') &&
               !el.closest('.mega-menu') &&
               !el.closest('header');
      }
    );
  }

  function atualizarContador(filtroEl, visiveis, total) {
    var contador = filtroEl.querySelector('[data-results-count]');
    var textoRes = filtroEl.querySelector('[data-results-text]');
    if (contador) contador.textContent = visiveis + ' produto' + (visiveis !== 1 ? 's' : '');
    if (textoRes) textoRes.textContent = visiveis === total
      ? 'Mostrando todos os ' + visiveis + ' produtos disponíveis'
      : 'Mostrando ' + visiveis + ' de ' + total + ' produtos';
  }

  function aplicar(filtroEl) {
    var select   = filtroEl.querySelector('[data-filter="category"]');
    var precoMin = filtroEl.querySelector('[data-filter="price-min"]');
    var precoMax = filtroEl.querySelector('[data-filter="price-max"]');
    var colecao  = select ? select.value : '';
    var minVal   = parseFloat(precoMin && precoMin.value) || 0;
    var maxVal   = parseFloat(precoMax && precoMax.value) || Infinity;

    var btnAp = filtroEl.querySelector('[data-action="apply"]');
    if (btnAp) { btnAp.disabled = true; btnAp.textContent = 'Filtrando...'; }

    function filtrarPorPreco(idsPermitidos) {
      var cards = getCardsHome();
      var idsVisiveis = {};
      cards.forEach(function(card) {
        var id   = card.dataset.productId;
        var item = card.closest('.resource-list__item') || card;
        var mostrar = true;

        if (idsPermitidos && !idsPermitidos[id]) mostrar = false;

        // Preço
        var precoEl = card.querySelector('.price__regular .money, .price-item--regular');
        if (precoEl) {
          var preco = parseFloat(precoEl.textContent.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
          if (minVal > 0 && preco < minVal) mostrar = false;
          if (maxVal < Infinity && preco > maxVal) mostrar = false;
        }

        item.style.display = mostrar ? '' : 'none';
        if (mostrar) idsVisiveis[id] = true;
      });

      var total = Object.keys(
        cards.reduce(function(acc, c) { acc[c.dataset.productId] = 1; return acc; }, {})
      ).length;

      atualizarContador(filtroEl, Object.keys(idsVisiveis).length, total);
      if (btnAp) { btnAp.disabled = false; btnAp.textContent = 'Aplicar'; }
    }

    if (colecao) {
      fetch('/collections/' + colecao + '/products.json?limit=250')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var ids = {};
          (data.products || []).forEach(function(p) { ids[String(p.id)] = true; });
          filtrarPorPreco(ids);
        })
        .catch(function() { filtrarPorPreco(null); });
    } else {
      filtrarPorPreco(null);
    }
  }

  function limpar(filtroEl) {
    var select   = filtroEl.querySelector('[data-filter="category"]');
    var precoMin = filtroEl.querySelector('[data-filter="price-min"]');
    var precoMax = filtroEl.querySelector('[data-filter="price-max"]');
    if (select)   select.value   = '';
    if (precoMin) precoMin.value = '';
    if (precoMax) precoMax.value = '';

    getCardsHome().forEach(function(card) {
      var item = card.closest('.resource-list__item') || card;
      item.style.display = '';
    });

    var cards = getCardsHome();
    var total = Object.keys(
      cards.reduce(function(acc, c) { acc[c.dataset.productId] = 1; return acc; }, {})
    ).length;
    atualizarContador(filtroEl, total, total);
  }

  rodar();

})();
